import { SSOPublicProvider } from "../../../shared/types";
import { useApp } from "../../hooks/use-app/useApp";
import { useLocalization } from "../../hooks/use-localization/useLocalization";
import { useQuery } from "../../hooks/use-query/useQuery";

const PROVIDER_LOGOS: Record<string, string> = {
  google:
    "https://res.cloudinary.com/rubics/image/upload/v1733212033/google_vqleeu.png",
  microsoft:
    "https://res.cloudinary.com/rubics/image/upload/v1733212033/microsoft_uk1krq.png",
};

export const Providers: React.FC<{
  providers: SSOPublicProvider[];
  hasEmailProvider?: boolean;
}> = ({ providers, hasEmailProvider }) => {
  const app = useApp();
  const query = useQuery();
  const { localize } = useLocalization();

  if (providers.length === 0) {
    return null;
  }

  return (
    <>
      {hasEmailProvider && (
        <div className="line-through b3">
          <span>Eller</span>
        </div>
      )}
      {providers.map((p) => {
        const logoUrl = PROVIDER_LOGOS[p.slug];

        return (
          <a
            key={p.slug}
            href={`/${app.name}/api/providers/${p.slug}${
              query.email && query.invite
                ? `?email=${query.email}&invite=${query.invite}`
                : ""
            }`}
            className="button secondary"
          >
            {logoUrl && <img src={logoUrl} alt={p.name} />}
            {localize("providerPrefix")} {p.name}
          </a>
        );
      })}
    </>
  );
};
